import {
    DevicePhoneMobileIcon,
    BeakerIcon,
    HomeModernIcon,
    AcademicCapIcon,
    CubeTransparentIcon,
    GlobeAmericasIcon, // Replaced TreePineIcon
    SunIcon, // Replaced LeafIcon
    ArchiveBoxIcon,
    ShoppingCartIcon,
    CakeIcon // approximated for food processing
} from '@heroicons/react/24/outline';

export const solutionsData = [
    {
        id: 'farmget-app-consultancy',
        title: 'Farmget App & On-Farm Consultancy',
        description: 'A smart farm management app with soil health monitoring, pest & disease forewarning, crop calendar, irrigation planning, and weather forecasts. Supported by our expert on-farm consultancy services, ensuring farmers receive personalized crop advisory and scientific solutions.',
        icon: DevicePhoneMobileIcon,
        image: 'https://images.unsplash.com/photo-1586771107445-d3ca888129ff?ixlib=rb-4.0.3&auto=format&fit=crop&w=1744&q=80'
    },
    {
        id: 'quality-agricultural-inputs',
        title: 'Quality Agricultural Inputs',
        description: 'Wide range of planting materials, seeds, fertilizers, biological products, crop protection solutions, and farm equipment. Ensuring timely access to trusted inputs for better yields.',
        icon: ShoppingCartIcon,
        image: 'https://images.unsplash.com/photo-1628352081506-83c43123ed6d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1740&q=80'
    },
    {
        id: 'protected-precision-farming',
        title: 'Protected & Precision Farming',
        description: 'Support for polyhouse, net house, and shade house cultivation. Precision farming solutions with sensor-based monitoring, automation, and smart irrigation systems.',
        icon: HomeModernIcon,
        image: 'https://images.unsplash.com/photo-1585320806297-9794b3e4eeae?ixlib=rb-4.0.3&auto=format&fit=crop&w=1744&q=80'
    },
    {
        id: 'research-innovation-support',
        title: 'Research & Innovation Support',
        description: 'Guidance on new farming techniques, modern crop varieties, and integrated nutrient & pest management. Collaboration with experts, consultants, and institutions to bring the latest innovations to farmers.',
        icon: AcademicCapIcon,
        image: 'https://images.unsplash.com/photo-1581093588401-fbb07e4c9e53?ixlib=rb-4.0.3&auto=format&fit=crop&w=1740&q=80'
    },
    {
        id: 'hydroponics-aeroponics',
        title: 'Hydroponics & Aeroponics Systems',
        description: 'Cutting-edge soilless cultivation systems for high-value crops. Solutions for commercial farms, greenhouses, urban farming, and agri-startups. Focus on water efficiency, faster growth, and year-round production.',
        icon: CubeTransparentIcon,
        image: 'https://images.unsplash.com/photo-1556736486-1d11340b6e92?ixlib=rb-4.0.3&auto=format&fit=crop&w=1740&q=80'
    },
    {
        id: 'landscaping-green-development',
        title: 'Landscaping & Green Development',
        description: 'Professional landscaping services for farms, institutions, corporates, and urban projects. Development of eco-friendly, aesthetic, and sustainable green spaces.',
        icon: GlobeAmericasIcon,
        image: 'https://images.unsplash.com/photo-1558904541-efa843a96f01?ixlib=rb-4.0.3&auto=format&fit=crop&w=1744&q=80'
    },
    {
        id: 'natural-farming',
        title: 'Natural Farming',
        description: 'Natural farming is a sustainable method of agriculture that works with nature instead of against it. It avoids synthetic chemicals and relies on bio-fertilizers, compost, crop rotation, and local resources to maintain soil fertility and crop health. This eco-friendly approach improves soil structure, conserves water, enhances biodiversity, and produces safe, nutritious food for healthier living.',
        icon: SunIcon,
        image: 'https://images.unsplash.com/photo-1500651230702-0e2d8a49d4ad?ixlib=rb-4.0.3&auto=format&fit=crop&w=1740&q=80'
    },
    {
        id: 'post-harvest-value-addition',
        title: 'Post-Harvest & Value Addition',
        description: 'Solutions for post-harvest management, storage, and processing. Support in developing value-added products for better market returns.',
        icon: ArchiveBoxIcon,
        image: 'https://images.unsplash.com/photo-1606041008023-472dfb5e530f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1736&q=80'
    },
    {
        id: 'agricultural-products-procurement',
        title: 'Agricultural Products Procurement',
        description: 'We directly buy fresh and quality farm produce from farmers at fair prices. This ensures farmers get better income while consumers receive safe, traceable, and reliable food products. Quality Assurance – Careful grading, sorting, and handling maintain the freshness and standards of the produce. Market Linkages – Connecting farmers directly with wholesalers, retailers, processors, and export markets.',
        icon: ShoppingCartIcon,
        image: 'https://images.unsplash.com/photo-1488459716781-31db52582fe9?ixlib=rb-4.0.3&auto=format&fit=crop&w=1740&q=80'
    },
    {
        id: 'agriculture-food-processing',
        title: 'Agriculture Food Processing',
        description: 'Agriculture food processing adds value to raw farm produce by cleaning, grading, preserving, packaging, and transforming it into ready-to-use or marketable products. From fruits, vegetables, grains, and pulses to dairy, spices, and oils, food processing reduces wastage, increases shelf life, and ensures consistent quality. It creates better income opportunities for farmers, promotes rural employment, and provides consumers with safe, hygienic, and nutritious food.',
        icon: CakeIcon,
        image: 'https://images.unsplash.com/photo-1542838132-92c53300491e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1674&q=80'
    }
];
